"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_NAME_MAX_LENGTH = exports.USER_NAME_MIN_LENGTH = void 0;
exports.USER_NAME_MIN_LENGTH = 4;
exports.USER_NAME_MAX_LENGTH = 80;
